// extracted by mini-css-extract-plugin
export default {"form":"Registration_form__36bYg","button":"Registration_button__J-eLM","gap":"Registration_gap__gzaTc"};